(() => {
  const isCartPage = () => /^\/(cart|checkout)(\/|$)/.test(window.location.pathname);

  const formatMoney = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const cartIcon = `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M3 4h2l1.9 9.1a2 2 0 0 0 2 1.6h7.8a2 2 0 0 0 1.9-1.4L20 8H7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      <circle cx="9.5" cy="19" r="1.25" fill="currentColor"/>
      <circle cx="17" cy="19" r="1.25" fill="currentColor"/>
    </svg>`;

  const ensureBar = () => {
    if (isCartPage()) return null;

    let bar = document.querySelector('.av-direct-pay-bar');
    if (bar) return bar;

    bar = document.createElement('aside');
    bar.className = 'av-direct-pay-bar';
    bar.setAttribute('aria-label', 'Cart and secure checkout');
    bar.innerHTML = `
      <a class="av-direct-pay-bar__cart" href="/cart" aria-label="Open cart">
        <span class="av-direct-pay-bar__icon" aria-hidden="true">
          ${cartIcon}
          <span class="av-direct-pay-bar__count" data-av-direct-count>0</span>
        </span>
        <span class="av-direct-pay-bar__copy">
          <strong data-av-direct-title>Cart</strong>
          <span data-av-direct-subtitle>Tap to review your items</span>
        </span>
      </a>
      <a class="av-direct-pay-bar__pay" href="/checkout">Pay Now</a>`;

    document.body.append(bar);
    document.body.classList.add('av-direct-pay-active');
    return bar;
  };

  let refreshTimer = 0;

  const refreshBar = async (emphasize = false) => {
    const bar = ensureBar();
    if (!bar) return;

    try {
      const response = await window.fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;

      const cart = await response.json();
      const count = Number(cart.item_count || 0);
      const title = bar.querySelector('[data-av-direct-title]');
      const subtitle = bar.querySelector('[data-av-direct-subtitle]');
      const countNode = bar.querySelector('[data-av-direct-count]');

      countNode.textContent = String(count);

      if (count > 0) {
        title.textContent = emphasize ? 'Added to cart ✓' : 'Cart ready';
        subtitle.textContent = `${count} ${count === 1 ? 'item' : 'items'} • ${formatMoney(cart.total_price, cart.currency)}`;
      } else {
        title.textContent = 'Cart';
        subtitle.textContent = 'Add a fragrance, then tap Pay Now';
      }

      if (emphasize) {
        bar.classList.remove('is-added');
        window.requestAnimationFrame(() => bar.classList.add('is-added'));
        window.setTimeout(() => bar.classList.remove('is-added'), 800);
        window.setTimeout(() => refreshBar(false), 2600);
      }
    } catch (_error) {
      /* The bar remains visible even if the cart request fails. */
    }
  };

  const scheduleRefresh = (emphasize = false) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(() => refreshBar(emphasize), 450);
    window.setTimeout(() => refreshBar(emphasize), 1100);
  };

  const start = () => {
    ensureBar();
    refreshBar(false);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof Element ? event.target.closest('form[action*="/cart/add"]') : null;
    if (form) scheduleRefresh(true);
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const addButton = target?.closest('button[name="add"], [data-add-to-cart], .av-add-to-cart, .av-buy-row button[type="submit"]');
    if (addButton) scheduleRefresh(true);
  }, true);

  ['cart:update', 'cart:refresh', 'product:added', 'ajaxProduct:added'].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleRefresh(true));
  });
})();
